import Cookies from 'js-cookie';

const handler = ( $ ) => {
	$( '.load-more-wrapper' ).on( 'click', function ( e ) {
		e.preventDefault();
		const $link = $( this ).find( '#ajax-load-more' ),
			$postsHolder = $( $link.data( 'posts-holder' ) );
		const offset = $postsHolder.find( '> div' ).length;
		$.ajax( {
			url: themeVars.ajaxurl,
			type: 'POST',
			dataType: 'json',
			data: {
				action: 'ajax_load_posts',
				query: $link.attr( 'data-current-query' ),
				post_type: $link.attr( 'data-post-type' ),
				posts_per_page: $link.attr( 'data-posts-per-page' ),
				post__not_in: $link.attr( 'data-post--not-in' ),
				offset,
				nonce: Cookies.get( 'wordpress_bilberrry_ajax_nonce' ),
			},
			beforeSend() {
				$postsHolder.addClass( 'is-loading' );
			},
			success( answer ) {
				$postsHolder.removeClass( 'is-loading' ).append( answer.html );

				$link.attr(
					'data-current-query',
					JSON.stringify( answer.query )
				);

				if ( answer.hide_link ) {
					$link.parent().hide();
				} else {
					$link.parent().show();
				}
			},
		} );
	} );
};

export default ( ( $ ) => $( handler ) )( jQuery );
